import { useState } from 'react';

// Owns the playground's full-screen expanded/collapsed state.
export const useFullScreenToggle = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggle = () => setIsFullScreen((prev) => !prev);

  return { isFullScreen, toggle };
};
